import * as React from 'react';
import { observer } from 'mobx-react';
import Base from '../../Base';
import { compose } from 'recompose';

import withAuthorization from '../session/withAuthorization';
import LoadingOverlay from '../LoadingOverlay';

class HomePage extends React.Component<any,any> {

  constructor(props) {
    super(props);

    //console.log(this.props);
  }

  componentDidMount() {
    //console.log("mounted");
    // this.props.props.toggleLoading(false);
    // console.log("MOUNTED!");
    // const { userStore } = this.props;

    //this.props.toggleLoading(false);

    // db.onceGetUsers().then(snapshot =>
    //   userStore.setUsers(snapshot.val())
    // );
  }

  render() {
    // const { users } = this.props.userStore;

    return (
      <div>
        {/* { !!users && <UserList users={users} /> } */}
        <Base/>
      </div>
    );
  }
}

// const UserList = ({ users }) =>
//   <div>
//     <h2>List of Usernames of Users</h2>
//     <p>(Saved on Sign Up in Firebase Database)</p>

//     {Object.keys(users).map(key =>
//       <div key={key}>{users[key].username}</div>
//     )}
//   </div>

const authCondition = (authUser) => !!authUser;

export default withAuthorization(authCondition, this.props)(HomePage);


// WEBPACK FOOTER //
// ./src/components/routes/Home.tsx